import React from 'react';

const About = () => {
    return (
        <div>
            <h1>Wanna about us?</h1>
        </div>
    );
};

export default About;